<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">supervised_user_circle</mat-icon>
				<span>Benutzererstellung</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bInProgress" />

		</div>


		<div class="mainColumn">

			<form [formGroup]="formG1" class="categPanel" autocomplete="off">

				<triv-input [fGroup]="formG1" [data]="myInputs.ebeId" />

				<div style="display: flex; flex-flow: column nowrap; gap: 10px;">

					<div>

						<div class="inputRowScreenColPhone">

							<mat-form-field
								style="flex-grow: 1;"
								appearance="outline"
								[class.fieldError]="passwordError"
								subscriptSizing="dynamic"
							>

								<mat-label>{{myInputs.ebePassword.label}}</mat-label>
								<input
									matInput 
									[type]="myInputs.ebePassword.type" 
									[formControlName]="myInputs.ebePassword.id" 
									[placeholder]="myInputs.ebePassword.placeholder || ''" 
									[spellcheck]="myInputs.ebePassword.spellcheck" 
									[required]="!!myInputs.ebePassword.required"
									class="{{myInputs.ebePassword.id}}_trivinput_{{myInputs.ebePassword.type}}"
									[value]="myInputs.ebePassword.defaultValue"
									[title]="myInputs.ebePassword.title || ''"
									autocomplete="new-password"
								>

							</mat-form-field>

							<mat-form-field
								style="flex-grow: 1;"
								appearance="outline"
								[class.fieldError]="passwordError"
								subscriptSizing="dynamic"
							>

								<mat-label>{{myInputs.ebePasswordCheck.label}}</mat-label>
								<input
									matInput 
									[type]="myInputs.ebePasswordCheck.type" 
									[formControlName]="myInputs.ebePasswordCheck.id" 
									[placeholder]="myInputs.ebePasswordCheck.placeholder || ''" 
									[spellcheck]="myInputs.ebePasswordCheck.spellcheck" 
									[required]="!!myInputs.ebePasswordCheck.required"
									class="{{myInputs.ebePasswordCheck.id}}_trivinput_{{myInputs.ebePasswordCheck.type}}"
									[value]="myInputs.ebePasswordCheck.defaultValue"
									[title]="myInputs.ebePasswordCheck.title || ''"
									autocomplete="new-password"
								>

							</mat-form-field>

						</div>

						<div style="font-size: smaller">
							Ein sicheres Passwort enthält 12 Zeichen, 1 Zahl, 
							1 Symbol (!"#$%&'*+,-./:;=?&#64;[]\^_`|~), 
							1 Großbuchstaben und 1 Kleinbuchstaben
						</div>

					</div>

					@if( passwordError ) {
						<div style="color: red; font-size: larger; text-align:center; max-width: 600px; margin: 0 auto;">
							{{passwordError}}
						</div>
					}
		
				</div>
				
				<div class="inputRowScreenColPhone">
					<triv-input [fGroup]="formG1" [data]="myInputs.ebeAnrede" />
					<triv-input [fGroup]="formG1" [data]="myInputs.ebeTitel" />
				</div>

				<div class="inputRowScreenColPhone">
					<triv-input [fGroup]="formG1" [data]="myInputs.ebeVorname" />
					<triv-input [fGroup]="formG1" [data]="myInputs.ebeName" />
				</div>
			
				<div class="inputRowScreenColPhone">
					<triv-input [fGroup]="formG1" [data]="myInputs.ebePosition" />
					<triv-input [fGroup]="formG1" [data]="myInputs.ebeTelefon" />
				</div>

				<div class="inputRowScreenColPhone">

					<mat-form-field
						style="flex-grow: 1;"
						appearance="outline"
						[class.fieldError]="emailCtrl.touched && emailCtrl.invalid"
					>

						<mat-label>{{myInputs.ebeMail.label}}</mat-label>
						<input
							matInput 
							type="email" 
							[formControlName]="myInputs.ebeMail.id" 
							[placeholder]="myInputs.ebeMail.placeholder || ''" 
							[spellcheck]="myInputs.ebeMail.spellcheck" 
							[required]="!!myInputs.ebeMail.required"
							class="{{myInputs.ebeMail.id}}_trivinput_{{myInputs.ebeMail.type}}"
							[value]="myInputs.ebeMail.defaultValue"
							[title]="myInputs.ebeMail.title || ''"
							autocomplete="off"
						>

						@if( emailCtrl.invalid && emailCtrl.touched ) {
							<mat-error>
								@if( emailCtrl.hasError( "alreadyUsed" ) ) {
									Diese E-Mail-Adresse wurde schon benutzt
								}
								@else if( emailCtrl.hasError( "emailInvalid" ) ) {
									Diese E-Mail wird als ungültig betrachtet
								}
								@else {
									{{myInputs.ebeMail.errorMsg}}
								}
							</mat-error>
						}

					</mat-form-field>

					<triv-input [fGroup]="formG1" [data]="myInputs.mitgliedId" />

				</div>

				<div class="inputRowScreenColPhone">
					<triv-input [fGroup]="formG1" [data]="myInputs.ansStrasse" />
					<triv-input [fGroup]="formG1" [data]="myInputs.ansHausnummer" />
				</div>

				<div class="inputRowScreenColPhone">
					<triv-input [fGroup]="formG1" [data]="myInputs.ansPlz" />
					<triv-input [fGroup]="formG1" [data]="myInputs.ansOrt" />
				</div>
			
				<div class="userFlags">

					<triv-input [fGroup]="formG1" [data]="myInputs.ebeAktiv" />

					@if( environment.features.datenpflege ) {
						<triv-input [fGroup]="formG1" [data]="myInputs.bMaintenanceRights" />
					}

					<triv-input [fGroup]="formG1" [data]="myInputs.bAdminMember" />

					@if( environment.features.export ) {
						<triv-input [fGroup]="formG1" [data]="myInputs.bExportRights" />
					}

					<mat-checkbox [formControl]="mainContactCtrl">
						Hauptansprechpartner
					</mat-checkbox>

				</div>

			</form>

			<div class="categPanel">
				<div class="aSubTitle">
					Veranstaltungsgruppen
				</div>
				<calendar-group-selector 
					userId="" 
					(newCalendarGroupsSelection)="selectedCalendarGroups = $event" 
				/>
			</div>

			<div class="categPanel">
				<div class="aSubTitle">
					News Rubriken
				</div>
				<rubric-selector
					userId=""
					(newRubricSelection)="selectedRubrics = $event"
				/>
			</div>

			<div class="categPanel">

				<div class="creatorButtons">
			
					<button
						mat-raised-button
						[routerLink]="['/Benutzerverwaltung']"
					>
						<mat-icon>home</mat-icon>
						Abbrechen
					</button>
			
					<button
						mat-raised-button
						(click)="formG1.reset()"
					>
						<mat-icon>history</mat-icon>
						Zurücksetzen
					</button>
			
					<button
						mat-flat-button
						(click)="clickCreate()"
						[disabled]="!formG1.valid || bInProgress"
					>
						<mat-icon>person_add</mat-icon>
						Erstellen
					</button>
			
				</div>
			
				@if( bError ) {
					<div class="errorWarning" style="text-align: center;">
						Beim Erstellen des Benutzers ist ein Fehler aufgetreten
					</div>
				}

			</div>

		</div>

	</div>

</div>




